import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const JobOffersStyled = styled.div`
  /* Mismo padding que el resto de páginas (candidatos, favoritos, ficha) */
  && {
    padding: 30px 60px;
  }

  .containerHeader {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 100%;
    /* Sin card blanca ni padding propio: el padding lo pone la raíz de la página */
    padding: 0;
    gap: 50px;
  }

  /* Resumen de filtros aplicados (react-select de solo lectura) */
  .selectContainer {
    min-width: 240px;
    max-width: 400px;
  }

  .sectionSecond {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;

    .title-block {
      display: flex;
      flex-direction: column;
      gap: 8px;
      max-width: 800px;
    }

    .title-row {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    /* Mismo contador que el de Candidatos, Favoritos... (#total de la app bar) */
    .title-total {
      font-size: 13px;
      font-weight: 500;
      line-height: 1;
      color: ${tokens.color.text.secondary};
      background-color: ${tokens.color.background.light};
      border-radius: 12px;
      padding: 5px 10px;
      white-space: nowrap;
    }

    .header-actions {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-shrink: 0;
    }

    label {
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 0px;
      margin-right: 20px;
    }
    input {
      font-size: 14px;
      font-family: 'Poppins';
    }

    & h2 {
      font-size: 20px; /* título de página de Velora, igual que candidatos y favoritos */
      font-weight: 600;
      line-height: 1.2;
      color: ${tokens.color.text.primary};
      margin-bottom: 0;
    }
    & h5 {
      font-size: 14px;
      font-weight: 400;
      color: ${tokens.color.text.tertiary};
      line-height: inherit;
    }

    & p {
      font-weight: 400;
      color: #7a808d;
    }
  }

  .MuiTableHead-root th:nth-child(n+5) {
    text-align: center !important;
    padding-right: 12px!important;
  }

  .MuiTableHead-root th:not(:nth-child(n+5)) {
    text-align: left !important;
  }

  .MuiTableHead-root th:first-child {
    min-width: 340px;
  }

  /* Acciones alineadas a la izquierda, como los iconos de la celda */
  .MuiTableHead-root th:last-child {
    text-align: left !important;
  }

  .headerTable {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h3 {
      margin-bottom: 0px;
    }
  }

  /* Filtros a la izquierda; filtrar y toggle Activos / Inactivos a la derecha */
  .offers-header {
    gap: 16px;
    flex-wrap: wrap;

    .offers-filters,
    .offers-actions {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    }
  }

  .containerButton {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
    height: 36px;
  }

  .MuiTableCell-root {
    font-family: 'Poppins';
  }
    
  .offerName {
      display: -webkit-box;
      -webkit-line-clamp: 2; /* Número de líneas a mostrar */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 3.6em;
  }
`

export default JobOffersStyled
